var installedModules = {};
var moduleToHandlerMapping = {
	70745: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(37580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	18109: {
		getter: () => (Promise.all([__webpack_require__.e(1235), __webpack_require__.e(7172)]).then(() => (() => (__webpack_require__(47172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	31235: {
		getter: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	90760: {
		getter: () => (Promise.all([__webpack_require__.e(3823), __webpack_require__.e(7141), __webpack_require__.e(2076), __webpack_require__.e(3734)]).then(() => (() => (__webpack_require__(3734))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	85244: {
		getter: () => (Promise.all([__webpack_require__.e(3823), __webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.8.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	82041: {
		getter: () => (Promise.all([__webpack_require__.e(1235), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(17699))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/platform",
	},
	79301: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(2814))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/coercion",
	},
	50709: {
		getter: () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(74879))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/keycodes",
	},
	82941: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(87912))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/layout",
	},
	24297: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(39539))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/observers",
	},
	75297: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(22810))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/coercion/private",
	},
	6521: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(37989))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/collections",
	},
	83281: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(63680))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/bidi",
	},
	53985: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(709), __webpack_require__.e(2941), __webpack_require__.e(4297), __webpack_require__.e(2102)]).then(() => (() => (__webpack_require__(72102))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/a11y",
	},
	27493: {
		getter: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(9168))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/portal",
	},
	7015: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(3281), __webpack_require__.e(709), __webpack_require__.e(1713), __webpack_require__.e(1570)]).then(() => (() => (__webpack_require__(81570))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/overlay",
	},
	51713: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(3281), __webpack_require__.e(6521), __webpack_require__.e(9975)]).then(() => (() => (__webpack_require__(79975))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/scrolling",
	},
	69059: {
		getter: () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(85689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	83719: {
		getter: () => (__webpack_require__.e(6745).then(() => (() => (__webpack_require__(56745))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/event-dispatch",
	},
	89081: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(3281), __webpack_require__.e(3985), __webpack_require__.e(709), __webpack_require__.e(4646)]).then(() => (() => (__webpack_require__(74646))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/core",
	},
	88386: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(31398))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk",
	},
	42493: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	62977: {
		getter: () => (Promise.all([__webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(8109), __webpack_require__.e(3281), __webpack_require__.e(4297), __webpack_require__.e(4950)]).then(() => (() => (__webpack_require__(24950))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/form-field",
	},
	80899: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(5541)]).then(() => (() => (__webpack_require__(95541))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/input",
	},
	55339: {
		getter: () => (__webpack_require__.e(4175).then(() => (() => (__webpack_require__(84175))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/button",
	},
	4333: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(3281), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(93482))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/dialog",
	},
	81833: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(98615))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/observers/private",
	},
	85891: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(46443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	9078: {
		getter: () => (Promise.all([__webpack_require__.e(5891), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	43853: {
		getter: () => (Promise.all([__webpack_require__.e(5244), __webpack_require__.e(1235), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(69940))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/text-field",
	},
	84207: {
		getter: () => (Promise.all([__webpack_require__.e(1235), __webpack_require__.e(2041), __webpack_require__.e(3281), __webpack_require__.e(1713), __webpack_require__.e(198)]).then(() => (() => (__webpack_require__(90198))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/table",
	},
	4027: {
		getter: () => (Promise.all([__webpack_require__.e(8109), __webpack_require__.e(655)]).then(() => (() => (__webpack_require__(10655))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	},
	81677: {
		getter: () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(5244), __webpack_require__.e(6561), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(81383))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/store",
	},
	6561: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(49074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	3673: {
		getter: () => (Promise.all([__webpack_require__.e(5244), __webpack_require__.e(9081), __webpack_require__.e(5891), __webpack_require__.e(9078), __webpack_require__.e(3840)]).then(() => (() => (__webpack_require__(93840))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/icon",
	},
	94219: {
		getter: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(52352))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk/clipboard",
	},
	65739: {
		getter: () => (__webpack_require__.e(3428).then(() => (() => (__webpack_require__(33428))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/google-maps",
	},
	9995: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(3281), __webpack_require__.e(3985), __webpack_require__.e(709), __webpack_require__.e(7493), __webpack_require__.e(7015), __webpack_require__.e(1713), __webpack_require__.e(2977), __webpack_require__.e(899), __webpack_require__.e(5339), __webpack_require__.e(1977)]).then(() => (() => (__webpack_require__(61977))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/datepicker",
	},
	7311: {
		getter: () => (Promise.all([__webpack_require__.e(2041), __webpack_require__.e(9301), __webpack_require__.e(3281), __webpack_require__.e(3985), __webpack_require__.e(709), __webpack_require__.e(7493), __webpack_require__.e(7015), __webpack_require__.e(1713), __webpack_require__.e(640)]).then(() => (() => (__webpack_require__(80640))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/material/tooltip",
	},
	2330: {
		getter: () => (__webpack_require__.e(1664).then(() => (() => (__webpack_require__(11664))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.12.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "libphonenumber-js",
	},
	71165: {
		getter: () => (__webpack_require__.e(9545).then(() => (() => (__webpack_require__(39545))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.29.4",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	97586: {
		getter: () => (__webpack_require__.e(852).then(() => (() => (__webpack_require__(90852))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^15.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/core",
	},
	12039: {
		getter: () => (Promise.all([__webpack_require__.e(1235), __webpack_require__.e(9078), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(95072))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.9",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	9370: {
		getter: () => (Promise.all([__webpack_require__.e(5244), __webpack_require__.e(9081), __webpack_require__.e(8109), __webpack_require__.e(6561), __webpack_require__.e(2493), __webpack_require__.e(3673), __webpack_require__.e(4052), __webpack_require__.e(7493), __webpack_require__.e(7015), __webpack_require__.e(5891), __webpack_require__.e(7586), __webpack_require__.e(2977), __webpack_require__.e(2039), __webpack_require__.e(899), __webpack_require__.e(6227), __webpack_require__.e(1785), __webpack_require__.e(3520)]).then(() => (() => (__webpack_require__(43520))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.1.479",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@papernest/app-design-system",
	},
	54612: {
		getter: () => (__webpack_require__.e(6492).then(() => (() => (__webpack_require__(86492))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.5",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "body-scroll-lock",
	},
	32487: {
		getter: () => (Promise.all([__webpack_require__.e(7872), __webpack_require__.e(5127)]).then(() => (() => (__webpack_require__(95127))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@sentry/browser",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"709": [
		50709
	],
	"745": [
		70745
	],
	"760": [
		90760
	],
	"899": [
		80899
	],
	"1235": [
		31235
	],
	"1677": [
		81677
	],
	"1713": [
		51713
	],
	"2039": [
		12039
	],
	"2041": [
		82041
	],
	"2093": [
		9370,
		54612
	],
	"2102": [
		75297
	],
	"2487": [
		32487
	],
	"2493": [
		42493
	],
	"2587": [
		4333
	],
	"2941": [
		82941
	],
	"2977": [
		62977
	],
	"3281": [
		83281
	],
	"3673": [
		3673
	],
	"3985": [
		53985
	],
	"4027": [
		4027
	],
	"4052": [
		94219,
		65739,
		9995,
		7311,
		2330,
		71165
	],
	"4297": [
		24297
	],
	"4646": [
		88386
	],
	"4950": [
		81833
	],
	"5244": [
		85244
	],
	"5339": [
		55339
	],
	"5541": [
		43853
	],
	"5891": [
		85891
	],
	"6521": [
		6521
	],
	"6561": [
		6561
	],
	"7015": [
		7015
	],
	"7493": [
		27493
	],
	"7580": [
		69059,
		83719
	],
	"7586": [
		97586
	],
	"7697": [
		84207
	],
	"8109": [
		18109
	],
	"9078": [
		9078
	],
	"9081": [
		89081
	],
	"9301": [
		79301
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}